export const getLayouts = async () => {
  return await window.axios.get('/layouts?filter[status]=active').then((data) => {
    return data.data;
  });
};
